import { render, staticRenderFns } from "./cutIn.vue?vue&type=template&id=510ad88d"
import script from "./cutIn.vue?vue&type=script&lang=js"
export * from "./cutIn.vue?vue&type=script&lang=js"
import style0 from "./cutIn.vue?vue&type=style&index=0&id=510ad88d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports